import { useState } from "react";
import { Button } from "@/components/ui/atoms/button";
import { DialogWithActions } from "@/components/ui/molecules/dialog-with-actions";

const DialogTest = () => {
  const [basicDialogOpen, setBasicDialogOpen] = useState(false);
  const [singleActionDialogOpen, setSingleActionDialogOpen] = useState(false);
  const [formDialogOpen, setFormDialogOpen] = useState(false);
  const [loadingDialogOpen, setLoadingDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  const handleLoadingAction = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setLoadingDialogOpen(false);
    }, 2000);
  };

  return (
    <div className="p-8 bg-neutral-10 min-h-screen">
      <h1 className="text-2xl font-bold text-primary-indigo-600 mb-6">
        Dialog Component Test
      </h1>

      <div className="flex flex-col gap-4 max-w-md">
        <Button onClick={() => setBasicDialogOpen(true)}>
          Open Dialog with Two Actions
        </Button>

        <Button onClick={() => setSingleActionDialogOpen(true)}>
          Open Dialog with Single Action
        </Button>

        <Button onClick={() => setFormDialogOpen(true)}>
          Open Dialog with Form
        </Button>

        <Button onClick={() => setLoadingDialogOpen(true)}>
          Open Dialog with Loading Action
        </Button>
      </div>

      {/* Basic Dialog with Two Actions */}
      <DialogWithActions
        open={basicDialogOpen}
        onOpenChange={setBasicDialogOpen}
        title="You can have the pop-up heading here"
        description="To get updates on WhatsApp, we need your mobile number linked to your profile."
        primaryActionText="Continue"
        onPrimaryAction={() => setBasicDialogOpen(false)}
        secondaryActionText="Not Now"
        onSecondaryAction={() => setBasicDialogOpen(false)}
      >
        <p>This is a basic dialog with two action buttons.</p>
      </DialogWithActions>

      {/* Dialog with Single Action */}
      <DialogWithActions
        open={singleActionDialogOpen}
        onOpenChange={setSingleActionDialogOpen}
        title="Notification"
        description="Your changes have been saved successfully."
        primaryActionText="OK"
        onPrimaryAction={() => setSingleActionDialogOpen(false)}
      >
        <p>This dialog only has a single action button.</p>
      </DialogWithActions>

      {/* Dialog with Form */}
      <DialogWithActions
        open={formDialogOpen}
        onOpenChange={setFormDialogOpen}
        title="Enter Phone Number"
        description="To get updates on WhatsApp, we need your mobile number linked to your profile."
        primaryActionText="Continue"
        onPrimaryAction={() => setFormDialogOpen(false)}
        secondaryActionText="Not Now"
        onSecondaryAction={() => setFormDialogOpen(false)}
        isPrimaryActionDisabled={!phoneNumber}
      >
        <div className="space-y-4">
          <div className="space-y-2">
            <label className="block text-sm font-medium mb-1">
              Phone Number
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 bg-neutral-800 border border-neutral-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-primary-indigo-500"
              placeholder="Enter your phone number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </div>
        </div>
      </DialogWithActions>

      {/* Dialog with Loading Action */}
      <DialogWithActions
        open={loadingDialogOpen}
        onOpenChange={setLoadingDialogOpen}
        title="Processing"
        description="Please wait while we process your request."
        primaryActionText="Continue"
        onPrimaryAction={handleLoadingAction}
        secondaryActionText="Cancel"
        onSecondaryAction={() => setLoadingDialogOpen(false)}
        isPrimaryActionLoading={isLoading}
        isPrimaryActionDisabled={isLoading}
      >
        <p>
          This dialog demonstrates a loading state on the primary action button.
        </p>
      </DialogWithActions>
    </div>
  );
};

export default DialogTest;
